import module from 'fan/proyecto/module.js'
import template from './template.html'

export class FanProyectoDocumentosPlantillaContenidoGuardarComponent {
  constructor (FanProyectoDocumentosPlantillaContenidoService) {
    this.FanProyectoDocumentosPlantillaContenidoService = FanProyectoDocumentosPlantillaContenidoService
    this.idProyecto = undefined
    this.idPlantilla = undefined
    this.version = undefined
    this.data = undefined
    this.onClose = undefined
    this.error = null
    this.procesando = false
    this.resultado = null
  }

  $onChanges (changes) {
    if (changes.data && this.data.nueva_version !== true) {
      this.data.nueva_version = false
    }
  }

  guardar () {
    if (this.procesando || this.resultado) return

    this.error = null
    this.procesando = true

    this.FanProyectoDocumentosPlantillaContenidoService.put(this.idProyecto, this.idPlantilla, this.version, this.data)
      .then((response) => (this.resultado = response.data))
      .catch((response) => (this.error = response.data))
      .finally(() => (this.procesando = false))
  }

  cerrar () {
    this.onClose({$event: {data: this.resultado}})
  }
}

module.component('fanProyectoDocumentosPlantillaContenidoGuardar', {
  controller: FanProyectoDocumentosPlantillaContenidoGuardarComponent,
  template: template,
  bindings: {
    idProyecto: '<',
    idPlantilla: '<',
    version: '<',
    data: '<',
    onClose: '&',
  },
})



// WEBPACK FOOTER //
// ./src/fan/proyecto/components/documentos/plantilla/contenido/guardar/component.js